module.exports = __webpack_public_path__ + "img/banner-1-m.6e0d6602.jpg";